// Lector de huella (servicio local del fabricante) — usado por Asistencia de la Clínica.
// Misma lógica que la captura del Catastro: el navegador habla con el servicio HTTP local del lector.
const getPath = (obj, path) => (path || "").split(".").reduce((o, k) => (o == null ? o : o[k]), obj);

export const UMBRAL_COINCIDENCIA_SECUGEN = 80; // SecuGen: puntaje 0-199; >= umbral = misma huella

export async function capturarDesdeServicioLocal(cfg) {
  const base = { Timeout: "10000", Quality: "50", licstr: "", templateFormat: "ISO", imageWID: "300", imageHGT: "400" };
  let extra = {};
  try { extra = cfg.parametros ? JSON.parse(cfg.parametros) : {}; } catch { extra = {}; }
  const params = cfg.adaptador === "secugen" ? { ...base, ...extra } : { ...extra };
  let resp;
  if ((cfg.metodo || "POST") === "GET") {
    const qs = new URLSearchParams(params).toString();
    resp = await fetch(qs ? `${cfg.url}${cfg.url.includes("?") ? "&" : "?"}${qs}` : cfg.url);
  } else if (cfg.formato_envio === "json") {
    resp = await fetch(cfg.url, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(params) });
  } else {
    resp = await fetch(cfg.url, { method: "POST", body: new URLSearchParams(params) });
  }
  const d = await resp.json();
  const err = getPath(d, cfg.campo_error);
  if (err !== undefined && err !== null && String(err) !== "0" && String(err) !== "") {
    throw new Error(`El lector respondió con error (${err}). Apoyá el dedo y reintentá.`);
  }
  const img = getPath(d, cfg.campo_imagen);
  if (!img) throw new Error("El lector no devolvió imagen. Revisá el campo de imagen en Configuración.");
  const imagen = String(img).startsWith("data:") ? img : `data:${cfg.mime_imagen || "image/bmp"};base64,${img}`;
  const template = getPath(d, cfg.campo_template) || null;
  return { imagen, template };
}

// Compara dos plantillas ISO con el servicio SecuGen (SGIMatchScore). Devuelve el puntaje o null si no se pudo.
export async function compararSecuGen(cfg, template1, template2) {
  if (cfg?.adaptador !== "secugen" || !template1 || !template2) return null;
  const url = (cfg.url || "").replace(/SGIFPCapture.*$/i, "SGIMatchScore");
  try {
    const r = await fetch(url, { method: "POST", body: new URLSearchParams({ Template1: template1, Template2: template2, licstr: "", templateFormat: "ISO" }) });
    const d = await r.json();
    if (d.ErrorCode !== undefined && String(d.ErrorCode) !== "0") return null;
    const sc = Number(d.MatchingScore);
    return Number.isFinite(sc) ? sc : null;
  } catch { return null; }
}
